var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"qr-code-stream-wrapper"},[_c('video',{ref:"video",staticClass:"qr-video",attrs:{"autoplay":"","playsinline":"","muted":""},domProps:{"muted":true}}),_c('canvas',{ref:"canvas",staticClass:"qr-canvas"})])}
var staticRenderFns = []

export { render, staticRenderFns }